/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import InputPhoneSmallLabel from 'DesignSystem/InputPhoneSmallLabel/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Comms/Phones/AddPhoneNumber/Content/Number",
  onChange,
  onSubmit
  
}) {
let phoneNumberNumberValueData = fromData.useDataValue({ viewPath,
context: 'phone_number',
path: 'number',
})
let phoneNumberNumberChangeData = fromData.useDataChange({ viewPath,
context: 'phone_number',
path: 'number',
})
let phoneNumberNumberSubmitData = fromData.useDataSubmit({ viewPath,
context: 'phone_number',
})
  return (<React.Fragment
>
<InputPhoneSmallLabel
  viewPath={`${viewPath}/InputPhoneSmallLabel`}
 label="Twilio number"
 marginRight={10}
 data="phone_number.number"
 validate="/Data/validate.js phoneNumber"
 required={true}
 value={phoneNumberNumberValueData}
 onChange={phoneNumberNumberChangeData}
 onSubmit={phoneNumberNumberSubmitData}
/>
{children}
</React.Fragment>)
}